export const OBTENER_PAISES_GET_DATA = 'OBTENER_PAISES_GET_DATA'
export const OBTENER_PAISES_FILTRO_DATA = 'OBTENER_PAISES_FILTRO_DATA'
export const GET_DATA_COUNTRY_CLONE = 'GET_DATA_COUNTRY_CLONE'
export const GET_DATA_COUNTRY_TOTAL = 'GET_DATA_COUNTRY_TOTAL'
